import { line } from 'd3';
import type { DrawableElem, LinePlotData, TextElem, XYChartConfig } from '../../interfaces.js';
import type { Axis } from '../axis/index.js';

export class LinePlot {
  constructor(
    private plotData: LinePlotData,
    private xAxis: Axis,
    private yAxis: Axis,
    private orientation: XYChartConfig['chartOrientation'],
    private plotIndex: number
  ) {}

  getDrawableElement(): DrawableElem[] {
    const finalData: [number, number][] = this.plotData.data.map((d) => [
      this.xAxis.getScaleValue(d[0]),
      this.yAxis.getScaleValue(d[1]),
    ]);

    let path: string | null;
    if (this.orientation === 'horizontal') {
      path = line()
        .y((d) => d[0])
        .x((d) => d[1])(finalData);
    } else {
      path = line()
        .x((d) => d[0])
        .y((d) => d[1])(finalData);
    }
    if (!path) {
      return [];
    }

    const elements: DrawableElem[] = [
      {
        groupTexts: ['plot', `line-plot-${this.plotIndex}`],
        type: 'path',
        data: [
          {
            path,
            strokeFill: this.plotData.strokeFill,
            strokeWidth: this.plotData.strokeWidth,
          },
        ],
      },
    ];

    if (this.plotData.pointLabels && this.plotData.pointLabels.length > 0) {
      const labelOffset = 10;
      const fontSize = 12;
      const textData: TextElem[] = [];

      for (const [i, [px, py]] of finalData.entries()) {
        const label = this.plotData.pointLabels[i];
        if (!label) {
          continue;
        }

        if (this.orientation === 'horizontal') {
          textData.push({
            x: py + labelOffset,
            y: px,
            text: label,
            fill: this.plotData.strokeFill,
            verticalPos: 'middle',
            horizontalPos: 'left',
            fontSize,
            rotation: 0,
          });
        } else {
          textData.push({
            x: px,
            y: py - labelOffset,
            text: label,
            fill: this.plotData.strokeFill,
            verticalPos: 'middle',
            horizontalPos: 'center',
            fontSize,
            rotation: 0,
          });
        }
      }

      if (textData.length > 0) {
        elements.push({
          groupTexts: ['plot', `line-plot-${this.plotIndex}`, 'labels'],
          type: 'text',
          data: textData,
        });
      }
    }

    return elements;
  }
}
